<div class="modal-header" id="internal-info-modal-title">
    <h3 class="modal-title" id="modal-title" translate="INTERNAL_INFO_TITLE"></h3>
    <span (click)="onClose()" class="close">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div>
        <pace-core-accordion
            [accordionOpened]="model.accordionOpenedStatus.contact"
            (openChanged)="model.accordionOpenedStatus.contact = true"
            [accordionInvalid]="contactModelValues.isInvalid"
            [isUnknownStatusAllowed]="false"
            [hasData]="!!model.contactModel.value.length"
            [showDataAvailabilityStatus]="true"
        >
            <div sectionHeader>
                @if (contactModelValues.icon) {
                    <fa-icon [icon]="contactModelValues.icon" class="ml-1 col-1 p-1"></fa-icon>
                }
                {{ INTERNAL_INFO_CATEGORY.CONTACT }}
            </div>
            <div sectionBody>
                <pace-internal-info-contact
                    [model]="model"
                    [parentForm]="contactChildren"
                    [categoryModel]="contactModelValues"
                    [isSaved]="isEdited"
                >
                </pace-internal-info-contact>
            </div>
            <div closeButton>
                <span translate="INTERNAL_INFO_CLOSE_BUTTON"></span>
            </div>
        </pace-core-accordion>
        <pace-core-accordion
            [accordionOpened]="model.accordionOpenedStatus.parking"
            (openChanged)="model.accordionOpenedStatus.parking = true"
            [accordionInvalid]="parkingModelValues.isInvalid"
            [isUnknownStatusAllowed]="false"
            [hasData]="parkingModelValues.isContentAvailable"
            [showDataAvailabilityStatus]="true"
        >
            <div sectionHeader>
                @if (parkingModelValues.icon) {
                    <fa-icon [icon]="parkingModelValues.icon" class="ml-1 col-1 p-1"></fa-icon>
                }
                {{ INTERNAL_INFO_CATEGORY.PARKING }}
            </div>
            <div sectionBody>
                <pace-internal-info-category
                    #parkingCategoryComponent
                    [model]="model"
                    [parentForm]="parkingChildren"
                    [categoryType]="INTERNAL_INFO_CATEGORY.PARKING"
                    [categoryModel]="parkingModelValues"
                >
                </pace-internal-info-category>
            </div>
            <div closeButton>
                <span translate="INTERNAL_INFO_CLOSE_BUTTON"></span>
            </div>
        </pace-core-accordion>
        <pace-core-accordion
            [accordionOpened]="model.accordionOpenedStatus.technicalSpec"
            (openChanged)="model.accordionOpenedStatus.technicalSpec = true"
            [accordionInvalid]="technicalSpecModelValues.isInvalid"
            [isUnknownStatusAllowed]="false"
            [hasData]="technicalSpecModelValues.isContentAvailable"
            [showDataAvailabilityStatus]="true"
        >
            <div sectionHeader>
                @if (technicalSpecModelValues.icon) {
                    <fa-icon [icon]="technicalSpecModelValues.icon" class="ml-1 col-1 p-1"></fa-icon>
                }
                {{ INTERNAL_INFO_CATEGORY.TECHNICAL_SPEC }}
            </div>
            <div sectionBody>
                <pace-internal-info-category
                    #technicalSpecCategoryComponent
                    [model]="model"
                    [parentForm]="technicalSpecChildren"
                    [categoryType]="INTERNAL_INFO_CATEGORY.TECHNICAL_SPEC"
                    [categoryModel]="technicalSpecModelValues"
                >
                </pace-internal-info-category>
            </div>
            <div closeButton>
                <span translate="INTERNAL_INFO_CLOSE_BUTTON"></span>
            </div>
        </pace-core-accordion>
        <pace-core-accordion
            [accordionOpened]="model.accordionOpenedStatus.organisation"
            (openChanged)="model.accordionOpenedStatus.organisation = true"
            [accordionInvalid]="organisationModelValues.isInvalid"
            [isUnknownStatusAllowed]="false"
            [hasData]="organisationModelValues.isContentAvailable"
            [showDataAvailabilityStatus]="true"
        >
            <div sectionHeader>
                @if (organisationModelValues.icon) {
                    <fa-icon [icon]="organisationModelValues.icon" class="ml-1 col-1 p-1"></fa-icon>
                }
                {{ INTERNAL_INFO_CATEGORY.ORG_MATTERS }}
            </div>
            <div sectionBody>
                <pace-internal-info-category
                    #organisationCategoryComponent
                    [model]="model"
                    [parentForm]="organisationChildren"
                    [categoryType]="INTERNAL_INFO_CATEGORY.ORG_MATTERS"
                    [categoryModel]="organisationModelValues"
                >
                </pace-internal-info-category>
            </div>
            <div closeButton>
                <span translate="INTERNAL_INFO_CLOSE_BUTTON"></span>
            </div>
        </pace-core-accordion>
        <pace-core-accordion
            [accordionOpened]="model.accordionOpenedStatus.constancyCheck"
            (openChanged)="model.accordionOpenedStatus.constancyCheck = true"
            [accordionInvalid]="constancyCheckModelValues.isInvalid"
            [isUnknownStatusAllowed]="false"
            [hasData]="constancyCheckModelValues.isContentAvailable"
            [showDataAvailabilityStatus]="true"
        >
            <div sectionHeader>
                @if (constancyCheckModelValues.icon) {
                    <fa-icon [icon]="constancyCheckModelValues.icon" class="ml-1 col-1 p-1"></fa-icon>
                }
                {{ INTERNAL_INFO_CATEGORY.CONSTANCY_CHECK }}
            </div>
            <div sectionBody>
                <pace-internal-info-category
                    #constancyCheckCategoryComponent
                    [model]="model"
                    [parentForm]="constancyCheckChildren"
                    [categoryType]="INTERNAL_INFO_CATEGORY.CONSTANCY_CHECK"
                    [categoryModel]="constancyCheckModelValues"
                >
                </pace-internal-info-category>
            </div>
            <div closeButton>
                <span translate="INTERNAL_INFO_CLOSE_BUTTON"></span>
            </div>
        </pace-core-accordion>
        <pace-core-accordion
            [accordionOpened]="model.accordionOpenedStatus.dispatch"
            (openChanged)="model.accordionOpenedStatus.dispatch = true"
            [accordionInvalid]="dispatchModelValues.isInvalid"
            [isUnknownStatusAllowed]="false"
            [hasData]="dispatchModelValues.isContentAvailable"
            [showDataAvailabilityStatus]="true"
        >
            <div sectionHeader>
                @if (dispatchModelValues.icon) {
                    <fa-icon [icon]="dispatchModelValues.icon" class="ml-1 col-1 p-1"></fa-icon>
                }
                {{ INTERNAL_INFO_CATEGORY.DISPATCH }}
            </div>
            <div sectionBody>
                <pace-internal-info-category
                    #dispatchCategoryComponent
                    [model]="model"
                    [parentForm]="dispatchChildren"
                    [categoryType]="INTERNAL_INFO_CATEGORY.DISPATCH"
                    [categoryModel]="dispatchModelValues"
                >
                </pace-internal-info-category>
            </div>
            <div closeButton>
                <span translate="INTERNAL_INFO_CLOSE_BUTTON"></span>
            </div>
        </pace-core-accordion>
        <pace-core-accordion
            [accordionOpened]="model.accordionOpenedStatus.subSystem"
            (openChanged)="model.accordionOpenedStatus.subSystem = true"
            [accordionInvalid]="subSystemModelValues.isInvalid"
            [isUnknownStatusAllowed]="false"
            [hasData]="subSystemModelValues.isContentAvailable"
            [showDataAvailabilityStatus]="true"
        >
            <div sectionHeader>
                @if (subSystemModelValues.icon) {
                    <fa-icon [icon]="subSystemModelValues.icon" class="ml-1 col-1 p-1"></fa-icon>
                }
                {{ INTERNAL_INFO_CATEGORY.SUB_SYSTEMS }}
            </div>
            <div sectionBody>
                <pace-internal-info-category
                    #subSystemCategoryComponent
                    [model]="model"
                    [parentForm]="subSystemChildren"
                    [categoryType]="INTERNAL_INFO_CATEGORY.SUB_SYSTEMS"
                    [categoryModel]="subSystemModelValues"
                >
                </pace-internal-info-category>
            </div>
            <div closeButton>
                <span translate="INTERNAL_INFO_CLOSE_BUTTON"></span>
            </div>
        </pace-core-accordion>
    </div>
</div>
<div class="modal-footer justify-content-between justify-content-md-end">
    <ng-container>
        <button
            [disabled]="!isEdited || isInvalid"
            (click)="save()"
            class="btn btn-primary"
            translate="INTERNAL_INFO_SAVE_BUTTON_LABEL"
        ></button>
        @if (hasUnsubmittedChanges) {
            <button
                [disabled]="isEdited || isInvalid"
                (click)="submitInternalInfo()"
                class="btn btn-primary"
                translate="INTERNAL_INFO_SUBMIT_BUTTON_LABEL"
            ></button>
        }
    </ng-container>
    @if (isLoading) {
        <progressbar [value]="100" type="default">Sending data...</progressbar>
    }
</div>
